module.exports = __webpack_public_path__ + "images/3f4eb6297ea1693043194863997ba5b7.gif";